module.exports = __webpack_public_path__ + "static/media/it.99136d7f.svg";